import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box } from '@mui/material';
import { Menu, X } from 'lucide-react';

interface ChatHeaderProps {
  onClose: () => void;
  onMenuClick: () => void;
  title?: string;
}

export function ChatHeader({ onClose, onMenuClick, title }: ChatHeaderProps) {
  return (
    <AppBar position="static" elevation={0} color="transparent" sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
      <Toolbar sx={{ minHeight: 44, px: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <IconButton
          size="medium"
          edge="start"
          sx={{ mr: 1, color: 'black', borderRadius: 2, '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}
          aria-label="menu"
          onClick={onMenuClick}
        >
          <Menu size={24} />
        </IconButton>
        <Typography variant="subtitle1" sx={{ flex: 1, fontWeight: 700, textAlign: 'center', fontSize: '18px', color: '#222222' }}>
          {title || 'New chat'} <span style={{ fontSize: '18px', marginLeft: 6, padding: '3px 14px', borderRadius: '24px', background: '#222222', color: '#fff' }}>AI</span>
        </Typography>
        <IconButton
          size="medium"
          edge="end"
          aria-label="close"
          onClick={onClose}
          sx={{ color: 'black', borderRadius: 2, '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' } }}
        >
          <X size={24} />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

